<template>
  <div style="background-color: #ffffff;">
    <MeterOrderDiagram ref="MeterViewDiagram" v-if="meter_id" :is-editor="true" @onClickMeter="onClickMeter" @onClickMeterId="onClickMeterId"/>
  </div>
</template>

<script>
import MeterOrderDiagram from "./components/MeterOrderDiagram";
export default {
  name: "MeterOrderMap",
  provide(){
    return{
      mainObj:this.mainObj,
      componentId:this.componentId,
      setComponentId:this.setComponentId,
    }
  },
  components: {MeterOrderDiagram},
  props:{
    meterId:[Number,String]
  },
  data(){
    return{
      meter_id:null,
      excel_list2:[],
      mainObj:{
        house_name:"",
        house_id:"",
        project_id:"",
        id:"",
        map_id:"",
        type:"",
        read_month:""
      },
      isEditor:"view",
      componentId:"MeterMain",
    }
  },
  mounted() {
    const that=this;
    let meter_id=that.$route.query.meterId;
    that.meter_id=meter_id;
    that.mainObj.map_id=meter_id;
    that.mainObj.project_id=that.$route.query.projectId;
    that.mainObj.read_month=that.$route.query.readMonth;
  },
  methods:{
    onClickMeter(node){
      const that=this;
      that.show(node.id,function () {
        setTimeout(function () {
          that.$refs.MeterViewDiagram.reData()
        },500)
      });
    },
    onClickMeterId(id){
      const that=this;
      that.show(id,function () {
        setTimeout(function () {
          that.$refs.MeterViewDiagram.reData()
        },500)
      });
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-1{
  >>>.el-dialog__body{
    padding: 0;
  }
  >>>.el-dialog__header{
    padding: 0;
  }
}
.meterMap{
  >>>.el-tabs__content{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderMap.vue